import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import { Tab } from '@mui/material'
import { Tabs } from 'components/UI'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// view components
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'
// views
import { ContentContainer } from './views'

interface Props {
  cta: React.ReactNode
  tab: number
  children: React.ReactNode
  isLoading: boolean
  onTabChange: (event: React.SyntheticEvent, value: number) => void
}

const ApiSettingsContent: React.FC<Props> = ({ tab, onTabChange, isLoading, cta, children }) => (
  <>
    <Helmet>
      <title>Skefto - API Settings</title>
    </Helmet>
    <MainLayoutContainer isLoading={isLoading} CTA={cta}>
      <NavigationSidebar config={settingsSidebarConfig} />
      <LayoutContainerInnerWrapper>
        <ContentContainer>
          <Tabs value={tab} onChange={onTabChange} indicatorColor='primary' textColor='primary' variant={null}>
            <Tab label='API' />
            <Tab label='Reporting' />
          </Tabs>

          {children}
        </ContentContainer>
      </LayoutContainerInnerWrapper>
    </MainLayoutContainer>
  </>
)

export default ApiSettingsContent
